import config from "../config";
import { filesRoute } from "../api/routes"
import { CUSTOMISED_ASSETS_BASE_URL } from "../config/FeatureDashboardVarMap"

export const getFeatureAssetBaseUrl = (isForced, forcedAssetDir = null) => {
    // This return is for local / non-s3, it will need another one for s3
    
    // console.log('PASS URL', isForced, process.env.REACT_APP_NODE_ENV,  config.axiosOrigin)
    if (process.env.REACT_APP_NODE_ENV === 'local') {
        if (!isForced) {
            return filesRoute + '/' + CUSTOMISED_ASSETS_BASE_URL + '/';
        }

        // In local dev, only default audio assets use S3 directly to avoid
        // CloudFront cache/CORS inconsistencies on specific audio files.
        // Keep default images/videos on CloudFront so preview visuals match
        // production CDN behavior.
        if (forcedAssetDir === 'audio' && config.s3BaseUrl) {
            return config.s3BaseUrl + '/' + CUSTOMISED_ASSETS_BASE_URL + '/';
        }
    }

    return config.cloudfrontBaseUrl + '/' + CUSTOMISED_ASSETS_BASE_URL + '/';
}

const resolveStoredAssetDir = (requestedType, assetData) => {
    const requested = String(requestedType || '').toLowerCase();
    const stored = String(assetData?.type || '').toLowerCase();

    if (stored === 'images') {
        return 'image';
    }

    if (stored === 'videos') {
        return 'video';
    }

    if (['image', 'audio', 'video'].includes(stored)) {
        return stored;
    }

    if (requested === 'images') {
        return 'image';
    }

    if (requested === 'videos') {
        return 'video';
    }

    if (requested === 'image' || requested === 'audio' || requested === 'video') {
        return requested;
    }

    return requested || stored || null;
};

export const resolveCustomAssetUrl = ({
    assetData,
    assetType,
    campaignId,
    defaultAssetFolder,
}) => {
    if (!assetData) return null;

    const filename = typeof assetData === 'string' ? assetData : assetData?.filename;
    if (!filename) return null;

    const resolvedDir = resolveStoredAssetDir(assetType, assetData);
    if (!resolvedDir) return null;

    if (assetData?.isDefault) {
        if (!defaultAssetFolder) return null;
        return `${getFeatureAssetBaseUrl(true, resolvedDir)}${defaultAssetFolder}/${resolvedDir}/${filename}`;
    }

    const sourceCampaignId = assetData?.assetSourceType === 'template' && assetData?.assetSourceCampaignId
        ? assetData.assetSourceCampaignId
        : campaignId;

    if (!sourceCampaignId) return null;

    return `${getFeatureAssetBaseUrl(false)}campaigns/${sourceCampaignId}/${resolvedDir}/${filename}`;
};

export const stripTemplateAssetSourceMetadata = (assetData) => {
    if (!assetData || typeof assetData !== 'object') {
        return assetData;
    }

    delete assetData.assetSourceType;
    delete assetData.assetSourceCampaignId;
    delete assetData.assetSourceTemplateId;
    return assetData;
};